import React from "react";
import { Link } from "react-router-dom";

export default function Button(props) {
  return (
    <div>
      <Link to={props.to} target="_blank" className={props.className}>
        {props.title}
      </Link>
    </div>
  );
}
